import { render, staticRenderFns } from "./FunderList.vue?vue&type=template&id=3e826b1e&"
import script from "./FunderList.vue?vue&type=script&lang=ts&"
export * from "./FunderList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports